import { Injectable } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class DateTimeService {

  constructor() { }

  /**
   * Get a string like: a year ago, a month ago or 5 days ago from current date.
   * @param timeStamp
   */
  getDuration(timeStamp: string):string{
    return moment(timeStamp, "YYYYMMDD").fromNow();
  }

  /**
   * Get a day string from date. eg. sun, mon
   * @param timeStamp
   */
  getDay(timeStamp: string): string{
    if(_.isEmpty(timeStamp))
      return '';
    return moment(timeStamp).format("ddd");
  }

  /**
   * Get the date difference in days
   * @param timeStamp
   */
  getDaysDifference(timeStamp: string): any{
    if(_.isEmpty(timeStamp)){
      return undefined;
    }
    let current = moment(new Date(), "YYYYMMDD");
    let input = moment(new Date(timeStamp), "YYYYMMDD");
    return input.diff(current, 'days');
  }

  /**
   * Get the color based on day difference.
   * @param timeStamp
   */
  getColor(timeStamp: string): string{
    if(_.isEmpty(timeStamp)){
      return 'lime';
    }
    let dayDiff = this.getDaysDifference(timeStamp);
    if(dayDiff === undefined){
      return 'red';
    }else if(dayDiff>0 && dayDiff <= 5 ){
      return 'orange';
    }else if(dayDiff > 5 && dayDiff <=10){
      return 'green';
    }else{
      return 'blue';
    }
  }

  /**
   *
   * @param timeStamp
   * @param format   date format
   */
  getDateFormat(timeStamp:any, format:any){
    if(timeStamp) return moment(timeStamp).format(format);
    return '';
  }

  getDateFormatStartOfDay(timeStamp:any){
    if(timeStamp) return moment(timeStamp).startOf('day').format('YYYY-MM-DDTHH:mm:ss').replace('T', ' ');
    return '';
  }

  getDateFormatEndOfDay(timeStamp:any){
    if(timeStamp) return moment(timeStamp).endOf('day').format('YYYY-MM-DDTHH:mm:ss').replace('T', ' ');
    return '';
  }

   /**
   * Temporary  Requiements for Date Difference, Need Sanction Screen Payload. Need MMDDYYYY
   */

  dateDiff(a:any, b:any){
    let startDate = moment(a);
    let endDate = moment(b)
    let diffDate = endDate.diff(startDate);
    const diffDuration = moment.duration(diffDate);
      return diffDuration.days();
  }
  /**
   *
   * @param timeStamp
   * @param format   time format
   */
  getTimeFormat(timeStamp:any, format:any){
    return moment(timeStamp).format(format);
  }


  addDaysToDate(timeStamp:any, days:any) {
    return moment(timeStamp).add(days, 'days').toDate()
  }

  subtractDaysToDate(timeStamp:any, days:any) {
    return moment(timeStamp).subtract(days, 'days').toDate()
  }

  formatDateWithTime(dateValue: any): string {
    if (!dateValue) return '';
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '';
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }
}
